import React, { useState } from "react";

import { useSpring, animated, config } from 'react-spring'

import {
    Flex,
    Image,
    Heading,
    Box,
    Text,
    Link,
    Button,
    VStack,
    SimpleGrid,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    ModalCloseButton,
} from "@chakra-ui/react";

import ModalVideo from 'react-modal-video';

import { internships } from "../../store/internships";

import { Icon  } from "@chakra-ui/react"

import map from "lodash/map";

import { AiOutlineInteraction } from "react-icons/ai";

const Interns = ({ thumbnails, desc, video, position, ...rest } : any ) => {

    const onClick = (e: any) => {

        e.preventDefault();

        const el = document.getElementById( e.target.parentElement.attributes.href.value.slice(1) );

        if ( el ) {

            el.scrollIntoView({
                behavior:"smooth"
            } );

        }

    };

    const [isOpen, setOpen] = useState(false);
    const [hover, setHover] = useState(false);
    const hoverState = useSpring({
        transform: hover
            ? 'translate3d(0px, -12px, 0px) scale(1.03)'
            : 'translate3d(0px, 0px, 0px) scale(1)',
        config: config.wobbly
    });

    const onClose = () => {
        setOpen(false)
    };

    return ( <>

            <Flex
                align="center"
                margin="0px auto"
                w="100%"
                display="block"
                position="relative"
                bg="#00000033"
                p="5px"
                mr={{ xxl: position != 1 ? '-152px;' : 'auto', xl: position != 1 ? '-152px;' : 'auto', xs: "auto", lg: "auto", md: "auto", sm: "auto"  }}
                ml={{ xxl: position == 1 ? '-202px' : 'auto', xl: position == 1 ? '-202px' : 'auto', xs: "auto", lg: "auto", md: "auto", sm: "auto"  }}
                _before={{
                    xxl: {
                        content: '"["' ,
                        position: "absolute",
                        left: '50%',
                        marginLeft: '-228px',
                        marginTop: '-8px',
                        fontSize: '16px',
                        fontFamily: 'Roboto',
                        color: '#ffffff'
                    },
                    xl: {
                        content: '"["' ,
                        position: "absolute",
                        left: '50%',
                        marginLeft: '-228px',
                        marginTop: '-8px',
                        fontSize: '16px',
                        fontFamily: 'Roboto',
                        color: '#ffffff'
                    },
                    xs: "",
                    lg: "",
                    md: "",
                    sm: ""
                }}
                _after={{
                    xxl: {
                        content: '"]"',
                        position: 'absolute',
                        bottom: '50px',
                        right: '-1px',
                        fontSize: '16px',
                        fontFamily: 'Roboto',
                        color: '#ffffff'
                    },
                    xl: {
                        content: '"]"',
                        position: 'absolute',
                        bottom: '50px',
                        right: '-1px',
                        fontSize: '16px',
                        fontFamily: 'Roboto',
                        color: '#ffffff'
                    },
                    xs: "",
                    lg: "",
                    md: "",
                    sm: ""
                }}
                {...rest}
            >

                <Box
                    w={{ xxl: "21%", xl: "21%", xs: "21%", lg: "100%", md: "100%", sm: "100%" }}
                    float={ [ 1 ,3 ].indexOf(position) >= 0
                        ? 'right'
                        : 'left'
                    }
                >

                    { map( thumbnails, ( thumbnail: any, key: any ) => (

                        <animated.div
                            style={{
                                width: '100%',
                                marginBottom: '3px',
                                ...hoverState
                            }}
                        >

                            <Image
                                src={thumbnail.src}
                            />

                        </animated.div>

                    ) ) }

                </Box>

                <Box
                    w={{ xxl: "77%", xl: "77%", xs: "77%", lg: "100%", md: "100%", sm: "100%" }}
                    bgSize="cover"
                    textAlign={{ xxl: "inherit", xl: "inherit", xs: "inherit", lg: "center", md: "center", sm: "center" }}
                    float={ [ 1 ,3 ].indexOf(position) >= 0
                        ? 'left'
                        : 'right'
                    }
                    p="0px 20px"
                >

                    <Text
                        m="0px"
                        fontSize={ { xxl: "11px", xl: "11px", xs: "11px", lg: "11px !important", md: "11px !important" } }
                        lineHeight={ { xxl: "1.6", xl: "1.6", xs: "1.4", lg: "1.4", md: "1.4" } }
                    >
                        {desc}
                    </Text>

                </Box>

                <Box>
                    <Link
                        srl_video_caption="Audio Track"
                        href="#video"
                        p="3px 0px 0px"
                        borderRadius="5px"
                        color="#ffffff !important"
                        textDecoration="none !important"
                        border="1px solid #ffffff"
                        onClick={() => setOpen(true)}
                        mt="10px"
                        mr={ { xxl: "auto", xl: "auto", xs: "auto", lg: "-6px", md: "-6px" } }
                        float="left"
                        textAlign="center"
                        w="100%"
                    >

                        <Button
                            bg="none"
                            fontSize="8px"
                            p="0px 30px"
                            className="internship-button"
                            mt="-3px"
                            w="100%"
                            _hover={{
                                bg: "none"
                            }}
                        >
                            ПОСМОТРЕТЬ ВИДЕО
                        </Button> </Link>
                </Box>

            </Flex>

            <Modal isOpen={isOpen} onClose={onClose}>

                <ModalOverlay />

                <ModalContent
                    p="0px"
                    minWidth={{ xxl: "600px", xl: "600px", xs: "600px", lg: "600px", md: "600px", sm: "350px" }}
                    w={{ xxl: "600px", xl: "600px", xs: "600px", lg: "600px", md: "600px", sm: "350px" }}
                >

                    <ModalCloseButton
                        position="absolute"
                        top="2px"
                        right="2px"
                        color="#ffffff"
                    />

                    <ModalBody p={0}>

                        <ModalVideo
                            channel="custom"
                            url={video}
                            isOpen={isOpen}
                            onClose={() => setOpen(false)}
                        />

                    </ModalBody>

                </ModalContent>

            </Modal>
        </>
    )
};

export default function Internship() {
    return (
        <>

            <Flex
                id="internship"
                align="center"
                justify={{ base: "center", md: "space-around", xl: "space-between" }}
                direction={{ base: "column-reverse", md: "row" }}
                bg="URL('./images/internership-old.png')"
                bgRepeat="no-repeat"
                bgSize="cover"
                w="100%"
                p={{ xxl: "25px 0px", xl: "25px 50px", xs: "25px 50px", lg: "25px 50px", md: "25px 50px", sm: "25px 50px" }}
            >

                <VStack
                    align="center"
                    margin="0px auto"
                    w="100%"
                    display="block"
                >

                    <Flex margin="0px auto">

                        <Heading
                            as="h2"
                            w="100%"
                            textAlign="center"
                            p="0px 0px 10px"
                            fontSize={{ xxl: "36px", xl: "36px", xs: "36px", lg: "36px", md: "20px", sm: "20px" }}
                            textTransform={ { xxl: "uppercase", xl: "uppercase", xs: "uppercase", lg: "uppercase", md: "uppercase", sm: "uppercase" } }
                        >

                            <Icon as={AiOutlineInteraction}
                                  bg="#e04e12"
                                  color="#ffffff"
                                  borderRadius="50%"
                                  border="1px solid #ffffff"
                                  p={ { xxl: "5px", xl: "5px", xs: "3px 5px", lg: "3px 5px", md: "3px 5px", sm: "3px 5px" } }
                                  m={ { xxl: "0px 5px 8px 0px", xl: "0px 5px 8px 0px", xs: "0px 5px 8px 0px", lg: "0px 5px 8px 0px", md: "0px 5px 8px 0px", sm: "0px 5px 8px 0px" } }
                            />

                            Стажировка в Европе

                        </Heading>

                    </Flex>

                <Flex
                    align="center"
                    maxW={{ xl: "450px" }}
                    w="100%"
                    m="0px auto ! important"
                >

                    <SimpleGrid
                        columns={1}
                        spacingX="40px"
                        spacingY="20px"
                        alignItems="center"
                        w="100%"
                    >

                        { map( internships, ( internship: any, key: any ) => (

                            <Interns
                                thumbnails={internship.images}
                                desc={internship.desc}
                                video={internship.video}
                                position={key}
                                key={key}
                            />

                        ) ) }

                    </SimpleGrid>

                </Flex>

            </VStack>

            </Flex>

        </>
    );
}
